import { render, staticRenderFns } from "./StudyHeader.vue?vue&type=template&id=7b1287e4&scoped=true&lang=pug"
import script from "./StudyHeader.vue?vue&type=script&lang=ts"
export * from "./StudyHeader.vue?vue&type=script&lang=ts"
import style0 from "./StudyHeader.vue?vue&type=style&index=0&id=7b1287e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1287e4",
  null
  
)

export default component.exports